import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';

@Component({
    selector: '.p-test-player'
})
export class TestPlayerComponent extends ComponentBase<HTMLElement> {

    private _player: any;
    private _playerLsd: any;

    public constructor(node: HTMLElement) {
        super(node);       
    }

    public onInit(): void {
        super.onInit();
        this._player = bc('player');
        this._playerLsd = bc('player-lsd');


        this._player.on('play', (e: any) => {
            this._playerLsd.play();
        });
        this._player.on('pause', (e: any) => {
            this._playerLsd.pause();
        });
        this._player.on('timeupdate', (e: any) => {
            console.log(this._playerLsd.currentTime(), this._player.currentTime());
            if (Math.abs(this._player.currentTime() - this._playerLsd.currentTime()) > 10) {
                console.log('update lsd time');
                this._playerLsd.currentTime(this._player.currentTime());
            }
        }); 
    }
}